const HomeDashboard = (state = [], action) => {
    switch (action.type) {
        case 'GET_HOME_DASHBOARD':
            return state;
        case 'SET_HOME_DASHBOARD'  :
            state = action.payload;
            return state;

        default:
            return state;
    }
};
export default HomeDashboard;







